import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'ui-user-block',
  templateUrl: './user-block.component.html',
  styleUrls: ['./user-block.component.scss']
})
export class UserBlockComponent {

  constructor() { }

}



// WEBPACK FOOTER //
// ./client/app/shared/blocks/user-block/user-block.component.ts